import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import React, { useEffect, useState } from "react";
import { Col, Row } from "react-bootstrap";
import ScrollableCard from "../../../../../SharedComponents/ScrollableCard";
import ApiHelper from "../../../../../../Helpers/ApiHelper";
import { folderEnum } from "../../../../../../Helpers/EnumHelper";

const SessionImages = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const selectedResult = useSelector((state) => state.candidate.selectedResult);
  const [imageArray, setImageArray] = useState([]);

  useEffect(() => {
    if (selectedResult?.jsonJpgNames) {
      setImageArray(JSON.parse(selectedResult?.jsonJpgNames));
    } else {
      setImageArray([]);
    }
  }, [selectedResult]);

  return (
    <Col>
      <ScrollableCard>
        <Row className={"h-100 mx-0 justify-content-center"}>
          {imageArray.map((imageName, i) => (
            <Col xs={"auto"} className={"p-0"} key={i}>
              <img className={"m-1"} alt={"image " + i} src={ApiHelper.cloudFrontURL + folderEnum.candidate + imageName} />
            </Col>
          ))}

          {imageArray.length === 0 && (

            <div className={"h-100 text-32 fw-medium py-5 text-color-gray-light text-center"} style={{
              backgroundColor: "#f5f5f5",
            }}>

              {t("noPicturesAvailable")}
            </div>
          )}

        </Row>

      </ScrollableCard>
    </Col>
  );
};
export default SessionImages;
